import 'css-chunk:src/feature/check/CheckVoids.module.scss';export default {
  "root": "CheckVoids_root"
};